<template>
  <base-badge :color="color">
    {{ text }}
  </base-badge>
</template>

<script>
export default {
  props: {
    productPromo: {
      required: true,
      type: Object,
    },
    type: {
      type: String,
      default: 'start'
    },
    append: Boolean
  },
  computed: {
    color() {
      if (this.type === 'export') {
        if (!this.productPromo.attributes.stock_export_status) {
          return 'gray';
        }

        return this.productPromo.attributes.stock_export_status === 'running' ? 'blue' : 'green'
      }

      if (this.productPromo.attributes.is_suspended) {
        return 'red';
      }

      if (this.productPromo.attributes.is_finished) {
        return 'blue';
      }

      if (this.productPromo.attributes.is_empty) {
        return 'gray';
      }

      if (!this.productPromo.attributes.is_active) {
        return 'gray';
      }

      return 'green';
    },
    text() {
      if (this.type === 'export') {
        if (!this.productPromo.attributes.stock_export_status) {
          return this.append ? 'Export Belum Dimulai' : 'Belum Dimulai';
        }

        if (this.append) {
          if (this.productPromo.attributes.stock_export_status === 'finished') {
            return 'Export Selesai'
          }

          return `Sedang Export ${this.productPromo.attributes.export_offices_count}/${this.productPromo.attributes.export_offices_completed}`
        }

        return this.productPromo.attributes.stock_export_status === 'running' ? 'Sedang Dibuat' : 'Selesai'
      }

      if (this.productPromo.attributes.is_suspended) {
        return 'Suspend';
      }

      if (this.productPromo.attributes.is_finished) {
        return 'Selesai';
      }

      if (this.productPromo.attributes.is_empty) {
        return 'Draft';
      }

      if (!this.productPromo.attributes.is_active) {
        return 'Draft';
      }

      return 'Sedang Berjalan';
    },
  },
};
</script>
